const PAGE_API_KEY = "fb42b20b64ceb9efc866056467a944bc";

module.exports = { PAGE_API_KEY };
